import React, { PureComponent } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import './TopNavBar.scss';

class TopNavBar extends PureComponent {
    static propTypes = {
        topNavData: PropTypes.object
    };
    constructor(props) {
        super(props);
        this.isScrolled = false;
        this.state = {
            headerScroll: false
        };
        this.handleScroll = this.handleScroll.bind(this);
    }
    componentDidMount() {
        window.addEventListener('scroll', this.handleScroll);
    }
    componentWillUnmount() {
        window.removeEventListener('scroll', this.handleScroll);
    }
    handleScroll() {
        const scrollTop = (window.pageYOffset !== undefined) ? window.pageYOffset : document.documentElement.scrollTop;
        if (scrollTop > 35) {
            this.setState({ headerScroll: true });
        } else {
            this.setState({ headerScroll: false });
        }
    }
    render() {
        const { topNavData, isSupported } = this.props;
        return (
            <div className="container-fluid">
                <div className="headeTopWrapper">
                    <div className={`topNav_bar is-${this.state.headerScroll ? 'scroll' : 'no-scroll'}`}>
                        {topNavData.topBarNavLeft && topNavData.topBarNavLeft.map(item => {
                            if (item.url && (item.url.indexOf('http') > -1)) {
                                return (
                                    <span key={JSON.stringify(item)} className={`menuItem ${item.label === 'CAREERS' ? 'hidden-sm' : ''}`}>
                                        {item.url ? (
                                            <a
                                                href={item.url}
                                                title={item.label}
                                                onClick={() => {
                                                    window.sessionStorage.setItem('previousChannel', window.dtm.channel);
                                                    if (item.url && item.url.indexOf('compare-looks') > -1) {
                                                        localStorage.setItem('dittoCompare', window.location.href);
                                                    }
                                                    window.dtm.LenskartRewamp.header.click.headerClick(this.props.section, item.label, this.props.loginStatus);
                                                }}
                                            >
                                                {item.label}
                                            </a>
                                        ) : ''}
                                    </span>

                                );
                            } else if (item.facetime) {
                                return (
                                    <a href={`tel:${item.facetime}`} onClick={() => { window.dtm.LenskartRewamp.header.click.headerClick(this.props.section, item.label, this.props.loginStatus); }}>{item.label}</a>
                                );
                            }
                            return (
                                <span key={item.label} className={`menuItem ${item.label === 'FRANCHISEE' ? 'hidden-sm' : ''}`}>
                                    {item.url && (isSupported ? true : !(item.url.indexOf('compare-looks') !== -1)) ? (
                                        <Link
                                            to={item.url}
                                            onClick={() => {
                                                window.sessionStorage.setItem('previousChannel', window.dtm.channel);
                                                if (item.url && item.url.indexOf('compare-looks') > -1) {
                                                    localStorage.setItem('dittoCompare', window.location.href);
                                                }
                                                window.dtm.LenskartRewamp.header.click.headerClick(this.props.section, item.label, this.props.loginStatus);
                                            }}
                                        >
                                            {item.label}
                                        </Link>
                                    ) : ''}
                                </span>);
                        })}
                    </div>
                    <div className="topRight">
                        {topNavData.topBarNavRight && topNavData.topBarNavRight.map(item => {
                            return (
                                <a
                                    className="topRightLink"
                                    href={item.url}
                                    title={item.label}
                                    key={item.label}
                                    onClick={() => {
                                        window.sessionStorage.setItem('previousChannel', window.dtm.channel);
                                        window.dtm.LenskartRewamp.header.click.headerClick(this.props.section, item.label, this.props.loginStatus);
                                    }}
                                >
                                    <i className={`${item.iconClass} topIcon`}></i>
                                    <span className="topSpan">{item.label}</span>
                                </a>
                            );
                        })}
                    </div>
                </div>
            </div>
        );
    }
}

TopNavBar.defaultProps = {
    topNavData: []
};

export default TopNavBar;
